import { useContext, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Badge,
  Box,
  Chip,
  Rating,
  Stack,
  Typography,
} from "@mui/material";
import {
  enableInsights,
  enableJira,
  enableZendesk,
  enableMailReply,
} from "../../utils/config";
import { getDateTime } from "../../utils/data";
import FeedbackDetails_new from "./FeedbackDetails";
import { UserData } from "../../model";
import { ReactNode } from "react";
import { Http, appLogger } from "../../utils";

import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import DeleteDialog from "../../utils/common/DeleteDialog";
import React from "react";

interface ReportAccordianProps {
  feedbackData: UserData;
  index: number;
  pageType: string;
  renderProVersion: (productId: string, productVersion: string) => ReactNode;
  renderSentiment: (sentiment: string) => ReactNode;
  getSignedUrl: (url: string) => void;
  handleMailDrawerOpen: (index: number) => void;
  handleDrawerOpen: (index: number) => void;
  inViewRef: (node?: Element | null | undefined) => void;
  setChartData: (test: any) => void;
  // handleReadMore: (index: number) => void;
}

const ReportAccordian = ({
  feedbackData,
  index,
  pageType,
  renderProVersion,
  renderSentiment,
  getSignedUrl,
  handleMailDrawerOpen,
  handleDrawerOpen,
  inViewRef,
  setChartData,
}: ReportAccordianProps) => {
  const { enabledFeatures, userInfo } = useContext(
    UserContext
  ) as UserLoginInfo;
  const [open, setOpen] = useState(false);
  const [isLoading, setIsloading] = React.useState(false);

  let userEnabledFeatures: any = localStorage.getItem("userenabledFeatures");
  if (userEnabledFeatures) {
    userEnabledFeatures = JSON.parse(userEnabledFeatures);
  }

  appLogger.info({
    infoObj: {
      method: "reportsDataRender",
      component: "feedback",
      fileName: "reports.tsx",
      element: feedbackData,
    },
  });

  const deleteFeedback = () => {
    const feedbackId = feedbackData.id;
    const feedbackMedia = feedbackData.feedbackMedia;
    setIsloading(true);
    appLogger.info(
      {
        infoObj: {
          method: "deleteFeedback",
          component: "feedback",
          fileName: "reports.tsx",
          request: { feedbackId, feedbackMedia },
        },
      },
      "Delete Feedback data"
    );
    let mediaName;
    if (feedbackMedia) {
      if (feedbackMedia.audio != "") {
        mediaName = feedbackMedia.audio;
      }
      if (feedbackMedia.video != "") {
        mediaName = feedbackMedia.video;
      }
      if (feedbackMedia.file != "") {
        mediaName = feedbackMedia.file;
      }
      if (feedbackMedia.image != "") {
        mediaName = feedbackMedia.image;
      }
    }
    const names = mediaName ? mediaName.split("/") : [];
    Http.deleteReq({
      url:
        names.length > 0
          ? `/api/v2/userFeedback/${feedbackId}/${names[names.length - 3]}/${
              names[names.length - 2]
            }/${names[names.length - 1]}`
          : `/api/v2/userFeedback/${feedbackId}`,
      state: userInfo,
    })
      .then((response: any) => {
        appLogger.info({
          infoObj: {
            method: "deleteFeedback",
            component: "feedback",
            fileName: "reports.tsx",
            deleteFeedbackResponse: response,
          },
        });
        setOpen(false);
        setIsloading(false);
        const test = {
          field: "DELETE",
          operation: "contains",
          value: [],
        };

        setChartData(test);
      })
      .catch((error) => {
        setOpen(false);
        setIsloading(false);
        appLogger.error({
          errObj: {
            method: "deleteFeedback",
            component: "feedback",
            fileName: "reports.tsx",
            err: error,
          },
        });
      });
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Accordion defaultExpanded>
      <AccordionSummary
        aria-controls={"panel" + `${index + 1}` + "-content"}
        id={"panel" + `${index + 1}` + "-header"}
      >
        <Typography className="user-mail">
          {feedbackData.userId ? feedbackData.userId : "Anonymous"}
        </Typography>
        {pageType != "FEATURE_REQUEST" ? (
          pageType == "FEEDBACK" ? (
            <Rating
              className={`ratings-clr-${feedbackData.productRating}`}
              name="read-only"
              value={feedbackData.productRating || 0}
              readOnly
            />
          ) : (
            <Stack
              direction="row"
              spacing={2}
              sx={{
                flexWrap: "wrap",
              }}
              className="ratings"
            >
              {feedbackData.bugPriority ? (
                <Chip
                  label={feedbackData.bugPriority}
                  color="primary"
                  variant="outlined"
                  className="bug-chip-text"
                />
              ) : (
                <h6 className="img-prv-lable">Unknown</h6>
              )}
            </Stack>
          )
        ) : (
          <></>
        )}
        {pageType == "FEATURE_REQUEST" && (
          <Typography sx={{ margin: "0 10px" }}></Typography>
        )}
        <Typography className="version">
          product :
          <span>
            {renderProVersion(
              feedbackData.productId || "",
              feedbackData.productVersion || ""
            )}
          </span>
          <span>, {feedbackData.productVersion || ""}</span>
        </Typography>
        {enableInsights &&
          enabledFeatures?.enableInsights &&
          feedbackData.sentiment && (
            <>{renderSentiment(feedbackData.sentiment)}</>
          )}
        <Typography className="created-date-header">Created on :</Typography>
        <Typography className="created-date">
          {feedbackData.createdOn ? getDateTime(feedbackData.createdOn) : ""}
        </Typography>
      </AccordionSummary>

      <AccordionDetails ref={inViewRef}>
        <FeedbackDetails_new datas={feedbackData} getSignedUrl={getSignedUrl} />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            p: 1,
            pl: 0,
          }}
        >
          <Box
            sx={{
              marginRight: "auto",
              display: "flex",
              alignItems: "center",
              paddingRight: 1,
            }}
          >
            <Typography className="modified-date-header">
              Modified on :
            </Typography>
            <Typography className="last-modified-date">
              {feedbackData.lastModifiedOn
                ? getDateTime(feedbackData.lastModifiedOn)
                : ""}
            </Typography>
          </Box>
          {feedbackData.extSysVal &&
          ((enableJira && userEnabledFeatures?.enableJira) ||
            (enableZendesk && userEnabledFeatures?.enableZendesk)) ? (
            // (enableJira || enableZendesk) &&
            //   (enabledFeatures?.enableJira || enabledFeatures?.enableZendesk)
            <Box className="read-more-link" style={{ display: "inline-block" }}>
              <Typography
                onClick={() =>
                  window.open(`${feedbackData.extSysVal?.url || ""}`, "_blank")
                }
              >
                {feedbackData.extSysVal.type} - {feedbackData.extSysVal.id}
              </Typography>
            </Box>
          ) : (
            <></>
          )}
          {feedbackData.zendeskSysVal &&
          // enableZendesk &&
          //   enabledFeatures?.enableZendesk ?
          enableZendesk &&
          userEnabledFeatures?.enableZendesk ? (
            <Box className="read-more-link" style={{ display: "inline-block" }}>
              <Typography
                onClick={() =>
                  window.open(
                    `${feedbackData.zendeskSysVal?.url || ""}`,
                    "_blank"
                  )
                }
              >
                {feedbackData.zendeskSysVal.type} -{" "}
                {feedbackData.zendeskSysVal.id}
              </Typography>
            </Box>
          ) : (
            <></>
          )}
          {feedbackData.jiraSysVal &&
          enableJira &&
          userEnabledFeatures?.enableJira ? (
            <Box className="read-more-link" style={{ display: "inline-block" }}>
              <Typography
                onClick={() =>
                  window.open(`${feedbackData.jiraSysVal?.url || ""}`, "_blank")
                }
              >
                {feedbackData.jiraSysVal.type} - {feedbackData.jiraSysVal.id}
              </Typography>
            </Box>
          ) : (
            <></>
          )}
          {feedbackData.userId &&
          enableMailReply &&
          userEnabledFeatures?.enableMailReply ? (
            <Box className="read-more-link" style={{ display: "inline-block" }}>
              <Typography onClick={() => handleMailDrawerOpen(index)}>
                <Badge
                  badgeContent={feedbackData.notificationCount}
                  color="primary"
                >
                  Reply
                </Badge>
              </Typography>
            </Box>
          ) : (
            <></>
          )}{" "}
          <Box
            id="read-more"
            className="read-more-link"
            style={{ display: "inline-block" }}
          >
            <Typography onClick={() => handleDrawerOpen(index)}>
              read more
            </Typography>
          </Box>
          <Box
            id="read-more"
            className="read-more-link"
            style={{ display: "inline-block" }}
          >
            <Typography onClick={() => setOpen(true)}>delete</Typography>
          </Box>
          {open && (
            <DeleteDialog
              deletepopupShow={open}
              deletepopupClose={handleClose}
              handleDeleteConfirm={deleteFeedback}
              type="feedback"
            />
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default ReportAccordian;
